<template>
  <div>
    <!-- <el-dialog :visible.sync="visible" custom-class="wxChat_global" title="" width="400px" @close="$emit('update:visible',false)">
      <div class="wxChat_top">
        <img :src="require('@/assets/image/chat/wx_system.png')">
        {{title}}
      </div>
      <div class="wxChat_search">
        <el-input
          placeholder="搜索客服"
          @input="cusFilter"
          v-model="wx_search">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="wxChat_main">
        <div class="cus_name" @click="cusQrcode(item)" v-for="item in cusFilterData" :key="item.id">
          <div>{{item.name}}</div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </el-dialog> -->
    <el-dialog :visible="visible" @close="$emit('update:visible',false)" custom-class="wxChat_global" title="" width="568px">
      <div class="wx_qrcode_main">
        <div class="wx_qrcode_left">
          <div class="wx_qrcode_left_top">
            <div class="left_top_sigh">!</div>
            <div>{{describe}}</div>
          </div>
          <div class="wx_qrcode_top_bottom">
            <ul>
              <li>聊天室功能暂时无法使用</li>
              <li>请在右侧扫码添加客服企业微信咨询</li>
            </ul>
          </div>
        </div>
        <div class="wx_qrcode_wrapper">
          <div class="wx_qrcode">
            <img :src="qr_code_url">
          </div>
          <div class="copy_tip">
            <img src="@/assets/image/Home/copyright.png">
            金华博淳网络科技
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="wx_bottom">
            扫码添加客服企业微信
            <img src="@/assets/image/chat/wx_global_ss.png">
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {apihurrylist,apiGetCustomerQrcodeInfo} from "@/request/API";

export default {
  name: 'wxChatGlobal',
  props: {
    describe: {
      type: String,
      default: ''
    },
    qr_code_url: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      qrcode_visible: false,
      // visible: false,
      wx_search:'',
      cusData: [],
      wx_qrcode: '',
      title: '',
      cusFilterData: []
    }
  },
  created() {
    // apiGetCustomerQrcodeInfo({
    //   type: 1
    // }).then(res => {
    //   console.log(res);
    //   if(res.data.customer_qr_code_flag==1){
    //     this.qrcode_visible = true
    //   }
    // })
    // apihurrylist().then(res => {
    //   this.cusData = res.data.data
    //   this.cusFilterData = res.data.data
    //   this.title = res.data.msg
    //   if(this.cusData.length>0){
    //     this.visible = true
    //   }
    // })
  },
  methods: {
    cusQrcode(item){
      this.wx_qrcode = item.qr_code_url
      this.qrcode_visible = true
    },
    cusFilter() {
      if(this.wx_search == ''){
        this.cusFilterData = JSON.parse(JSON.stringify(this.cusData))
      }else{
        this.cusFilterData = JSON.parse(JSON.stringify(this.cusData)).filter(item => {
          if(item.name&&item.name.indexOf(this.wx_search)!=-1){
            return item
          }
        })
      }
    }
  },
  watch: {
    // visible(val) {
    //   if (val) {
    //     this.wx_search = ''
    //   } else {
    //   }
    // }
  }
}
</script>

<style lang="less">
.wxChat_global{
  border-radius: 4px !important;
  padding: 0;
  .el-dialog__header {
    // display: none;
    padding: 0;
    .el-dialog__headerbtn{
      top: 10px;
      right: 10px;
      font-size: 20px;
    }
  }

  .el-dialog__body {
    padding: 0 !important;
    background: transparent;
  }
  .wxChat_top{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #A3A3A3;
    padding: 27px 0 20px;
  }
  .wxChat_search{
    margin: 0 20px;
    .el-input__inner{
      border-radius: 4px;
    }
  }
  .wxChat_main{
    height: 283px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 6px; /*对垂直流动条有效*/
      height: 10px;
    }
    /*定义滚动条的轨道颜色、内阴影及圆角*/
    &::-webkit-scrollbar-track {
      background-color: rgba(255, 255, 255, 0);
      border-radius: 3px;
    }
    /*定义滑块颜色、内阴影及圆角*/

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: #D3D3D3;
    }
    .cus_name{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 42px;
      padding: 0 40px;
      border-top: 1px #F7F7F7 solid;
      >div{
        max-width: 250px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      
      &:hover{
        background: #F6F6F6;
      }
      &:first-child{
        border: none;
      }
    }
  }
  .wx_qrcode_main{
    display: flex;
    justify-content: space-between;
    width: 568px;
    .wx_qrcode_left{
      width: 268px;
      background: #1A1D24;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      box-sizing: border-box;
      padding: 0 30px;
      .wx_qrcode_left_top{
        border-bottom: 1px solid rgba(255,255,255,0.2);
        font-size: 18px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        padding-bottom: 40px;
        .left_top_sigh{
          border-radius: 50%;
          width: 50px;
          height: 50px;
          background: linear-gradient(180deg, #F7F5F2 0%, #D8D2CA 100%);
          line-height: 50px;
          text-align: center;
          font-size: 36px;
          margin-bottom: 10px;
        }
      }
      .wx_qrcode_top_bottom{
        padding-top: 20px;
        ul{
          padding-left: 15px;
          li{
            list-style:disc;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 20px;
          }
        }
      }
    }
  }
  .wx_qrcode_wrapper{
    width: 300px;
    margin: 0 auto;
    padding: 50px 0 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .wx_qrcode{
      width: 220px;
      height: 220px;
      background: url(../../../assets/image/chat/qr_code_bg.png);
      padding: 10px;
      box-sizing: border-box;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .copy_tip{
      display: flex;
      align-items: center;
      margin: 12px 0 20px;
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      img{
        width: 15.28px;
        height: 18.06px;
        margin-right: 6px;
      }
    }
    .wx_bottom{
      display: flex;
      align-items: center;
      font-size: 18px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      img{
        width: 15px;
        height: 15px;
        margin-left: 8px;
      }
    }
  }
}
</style>
